export const IS_TH = true;
export const IS_BK = false;
